import { ease } from '../../visualizations/common/directives/svgTransition.js';
export const timing = (animate: boolean) => animate ? {
  easing: ease.outCubic,
  duration: 500
} : {
  easing: ease.outCubic,
  duration: 0
};